module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mG2bKx/tc-custom/9781614236573.jpg?1705766093576",
      "alt": "This image is the cover for the book Ghosts of Old Town Albuquerque, Haunted America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ghosts of Old Town Albuquerque, Haunted America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Meet the spirits who haunt this historic New Mexico city . . . photos included!")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Old Town Plaza has been the center of Albuquerque community life since the city was founded in 1706 by Gov. Francisco Cuervo y Valdez. Historically known as the crossroads of the Southwest, and reflecting an amalgamation of Spanish, Mexican, and Native American cultures, Old Town Plaza has been home to many of New Mexico’s proud ancestors—and still is."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Ghosts of Old Town Albuquerque")]), _vm._v(" presents the evidence of their specters wandering the shadows, gathered by author Cody Polston, president of the Southwest Ghost Hunter’s Association. Having tracked spirits for three decades, including in such landmarks as the Bottger Mansion and Casa de Ruiz, Polston explores the history and mysteries behind many of Old Town Plaza’s eerie wraiths."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Cody Polston\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Cody Polston is the president and founder of the Southwest Ghost Hunters Association. He is a three-time author of books about ghosts and ghost hunting.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Haunted America\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0